var React = require('react');

export class Profile extends React.Component {
  constructor (props) {
    super(props);

    this.updateProfileInfo = this.updateProfileInfo.bind(this);
    this.submitVerificationCode = this.submitVerificationCode.bind(this);
    this.sendEmailVerificationCode = this.sendEmailVerificationCode.bind(this);
  }

  static updateProfileInfo (userSSOid, profileStr, callback, optionalCBArgs) {
    let sendOptions;
    const accessToken = PSSessions.Cookies('PSAccess');
    const url = "/v1/profiles/" + userSSOid;
    $.ajax({
      cache: false,
      type: 'PUT',
      context: this,
      url: url,
      data: profileStr,
      headers: {
        'Authorization': 'Bearer ' + accessToken,
        'Content-Type': 'application/json'
      }
    }).done(function(response, textStatus, jqXHR) {
      return callback(response, textStatus, jqXHR, optionalCBArgs);
    });
  }

  static submitVerificationCode (payloadStr, callback) {
    const accessToken = PSSessions.Cookies('PSAccess');
    $.ajax({
      url: "/v1/profiles/me/email/verify",
      context: this,
      type: "PUT",
      headers: {
        'Authorization': 'Bearer ' + accessToken,
        'Content-Type': 'application/json'
      },
      data: payloadStr,
      success: callback,
      error: callback
    });
  }

  static sendEmailVerificationCode (callback) {
    const accessToken = PSSessions.Cookies('PSAccess');
    $.ajax({
      url: "/v1/profiles/me/email/verify",
      type: "GET",
      headers: {
        'Authorization': 'Bearer ' + accessToken,
        'Content-Type': 'application/json'
      },
      success: callback,
      error: callback
    });
  }

  render () {
    return null;
  }
}
